import { useEffect } from "react"
import { useNavigate } from "react-router"
import { useAppDispatch, useAppSelector } from "../../lib/redux/hook"
import { formatAmount } from "../../lib/utilis"
import { EditIcon } from "../../ui/icons/editIcon"
import { Dropdown } from "../../ui/organisms/dropDown"
import { ErrorPopup } from "../../ui/organisms/errorPopup"
import { SuccessPopup } from "../../ui/organisms/successPopup"
import { findAllInvoiceAmount, setCreateInvoiceAmountCents, setCreateInvoiceAmountStatus } from "./slice"

export function InvoiceAmountList() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const invoiceAmountState = useAppSelector(state => state.invoiceAmount)

    const formatMonthName = (month: number) => {
        const monthNames = [
            "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
            "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
        ];
        return monthNames[month - 1];
    }

    useEffect(() => {
        if (invoiceAmountState.createInvoiceAmountStatus === "successfully") {
            dispatch(findAllInvoiceAmount({ ...invoiceAmountState.invoiceAmountFilters, page: invoiceAmountState.invoiceAmountFilters.page }))
        }
    }, [invoiceAmountState.createInvoiceAmountStatus])

    return (
        <div className="w-full flex flex-col gap-4 bg-neutral-100 rounded-tr-xl rounded-tl-xl overflow-auto">
            <SuccessPopup
                message="Importo fattura creato con successo!"
                active={invoiceAmountState.createInvoiceAmountStatus === 'successfully'}
                close={() => dispatch(setCreateInvoiceAmountStatus('idle'))}
            />
            <ErrorPopup
                message="L'inserimento dell'importo fattura non è andata a buon fine."
                active={invoiceAmountState.createInvoiceAmountStatus === 'failed'}
                close={() => { dispatch(setCreateInvoiceAmountCents(0)); dispatch(setCreateInvoiceAmountStatus('idle')) }}
            />
            <div>
                <table className="w-full">
                    <thead className="h-[56px] font-semibold text-neutral-500 text-text-xs">
                        <tr>
                            <th className="text-left">
                                <div className="flex py-4 px-4 gap-1" >
                                    MESE
                                </div>
                            </th>
                            {
                                invoiceAmountState.findAllInvoiceAmountResponse?.invoice_amounts.length !== 0 &&
                                <>
                                    <th className="text-left">
                                        ANNO
                                    </th>
                                    <th className="text-left">
                                        COSTO MENSILE CLOUD
                                    </th>
                                    <th className="text-left">
                                        <div className="flex py-4 px-2 gap-1" />
                                    </th>
                                </>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            invoiceAmountState.findAllInvoiceAmountResponse?.invoice_amounts.length === 0 ?
                                <tr className="bg-white h-[56px] border-b-[1px] border-b-neutral-100 w-full">
                                    <td className="py-4 px-4 text-text-sm font-medium text-neutral-500">
                                        Nessun importo fattura
                                    </td>
                                </tr>
                                :
                                [...(invoiceAmountState.findAllInvoiceAmountResponse?.invoice_amounts || [])]
                                    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
                                    .map(item =>
                                    <tr
                                        className="bg-white h-[56px] border-b-[1px] border-b-neutral-100"
                                        key={item.id}
                                    >
                                        <td onClick={() => navigate('/invoice-amount/' + item.id)} className="py-4 px-2 text-text-sm font-semibold text-neutral-600 hover:text-neutral-500 cursor-pointer">{formatMonthName(item.month)}</td>
                                        <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{item.year}</td>
                                        <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{formatAmount(item.amount_cents) + " €"}</td>
                                        <td className="w-[40px] cursor-pointer">
                                            <Dropdown items={[
                                                {
                                                    label: 'Visualizza',
                                                    icon: <EditIcon color="" size={""} />,
                                                    onClick: () => {
                                                        navigate('/invoice-amount/' + item.id)
                                                    }
                                                }
                                            ]} />
                                        </td>
                                    </tr>
                                )
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}